import { render, staticRenderFns } from "./PurchaseOrderCloseForm.vue?vue&type=template&id=7f0f703e&"
import script from "./PurchaseOrderCloseForm.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderCloseForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f0f703e')) {
      api.createRecord('7f0f703e', component.options)
    } else {
      api.reload('7f0f703e', component.options)
    }
    module.hot.accept("./PurchaseOrderCloseForm.vue?vue&type=template&id=7f0f703e&", function () {
      api.rerender('7f0f703e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PurchaseOrder/PurchaseOrderCloseForm.vue"
export default component.exports